import styled, { keyframes } from 'styled-components'
import Colors from '../../theme/colors';

export const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`

export const fadeUp = keyframes`
    from {
        transform: translateY(60px);
        opacity: 0;
    }

    to {
        transform: translateY(0px);
        opacity: 1;
    }
`

export const Pill = styled.div`
    margin-top: 16px;
    margin-bottom: 8px;
    color: #000;
    background-color: #E8E8E8;
    text-align: center;
    padding: 4px 16px;
    border-radius: 24px;
    font-size: 14px;
`;

export const IconWrapper = styled.div`
  align-self: center;
  margin: 10px;
`;

export const ImageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

export const Container = styled.div`
  background-color: #FCFCFC;
  padding: 0 24px 24px 24px;

  h2 {
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 600;
  }
`
export const media = {
    lg: (styles) => `
        @media only screen and (max-width: 1b00px) {
            ${styles}
        }
    `,
    md: (styles) => `
        @media only screen and (max-width: 1200px) {
            ${styles}
        }
    `,
    sm: (styles) => `
        @media only screen and (max-width: 768px) {
            ${styles}
        }
    `,
    xs: (styles) => `
        @media only screen and (max-width: 480px) {
            ${styles}
        }
    `
}
export const Row = styled.div`
    display: flex;
    margin-bottom: 32px;
`

export const Col = styled.div`
    flex: ${(props) => props.size};
    align-self: center;
    ${(props) => props.collapse && media[props.collapse](`
        display: none;
    `)}
`

export const Input = styled.input`
    padding: 8px;
    box-sizing: border-box;
    background-color: #FCFCFC;
    font-size: 16px;
    border: 0.5px solid rgba(8,23,23,0.2);
    border-radius: 2px;
    display: block;
    width: 100%;
    color: rgba(8,23,23,0.2);
    margin-bottom: 0px;
    text-align: ${(props) => props.align};
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: rgba(8,23,23,0.2);
    }
`

export const Select = styled.select`
    padding: 8px;
    box-sizing: border-box;
    background-color: #FCFCFC;
    font-size: 16px;
    border: 0.5px solid rgba(8,23,23,0.2);
    border-radius: 2px;
    display: block;
    width: 100%;
    color: rgba(8,23,23,0.2);
    margin-bottom: 0px;
`

export const Button = styled.button`
  background-color: ${Colors.Trust.Primary};
  color: white;
  border: none;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 3px;
  margin-top: 18px;
`;

export const Text = styled.p`
    color: ${Colors.Black};
    font-weight: 400;
    font: 16px;
`

export const Link = styled.a`
    color: ${(props) => props.color};
    font-size: ${(props) => props.size};
    text-decoration: none;
    text-align: center;
    padding-top: 16px;
`

export const Panel = styled.div`
    background-color: ${Colors.Neutral.Light1};
    border: 1px solid ${Colors.Neutral.Shade};
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    min-height: 124px;

    .amount {
        display: flex;
        align-items: center;
    }

    .currency {
        font-size: 16px;
        font-weight: 600;
        margin-inline-end: 10px;
    }

    .value {
        font-size: 42px;
        font-weight: 600;
    }

    .title {
        font-size: 16px;
        color: black;
        font-weight: 600;
        text-align: center;
    }

    .text {
        font-size: 16px;
        color: ${Colors.Neutral.Shade};
        text-align: center;
    }

    .clientLogo {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        margin-top: 4px;
    }
`;

export const SDKContainer = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.isActive ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0)'};
    overflow: hidden;
    transition: background-color 500ms;
    pointer-events: ${(props) => props.isActive ? 'auto' : 'none'};
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
    padding: 24px 8px 24px 8px;
    
    @media screen and (min-width: 470px) {
        align-items: center;
    }
`

export const Modal = styled.div`
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    background-color: white;
    border-radius: 32px;
    max-height: 650px;
    padding: 24px 24px 0 24px;
    display: flex;
    flex-direction: column;
    transform: translateY(${(props) => props.isActive ? '0px' : '3000px'});
    transition: transform 300ms;
    overflow: hidden !important;

    @media screen and (min-width: 470px) {
        max-width: 363px;
    }
`

export const Content = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const Flex = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const Load = styled.img`
    display: inline-block;
    animation: ${rotate} 1s linear infinite;
    width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
`

export const PermissionsBar = styled.div`
    background-color: #F4F5F5;
    font-size: 12px;
    color: #626A6A;
    text-align: center;
    padding: 16px 0;
    position: absolute;
    width: 100%;
    top: 148px;
    left: 0;
    z-index: 500;
`

export const PermissionsCant = styled.div`
    h3 {
        color: #081717;
        font-size: 14px;
        font-weight: 600;
        margin: 0 0 8px 0;
    }

    ul {
        margin: 0;
        list-style-type: none;
        font-size: 12px;
        color: #081717;
        padding-left: 0px;

        li {
            padding: 0 0 8px 0;

            &::before {
                color: #FF5533;
                content: "×";
                font-size: 16px;
                margin-right: 16px;
            }
        }
    }
` 

export const Scroll = styled.div`
    flex-grow: 1;
    overflow: hidden;
    overflow-y: scroll;
    padding-bottom: 120px;
    position: relative;
`
